import {
  BookOpen,
  Receipt,
  Globe,
  Users,
  BarChart3,
  CloudCheck,
  TrendingUp,
  Handshake,
  ChevronRight,
} from "lucide-react";

export function ServiceCard({ icon, title, description, featured = false }) {
  const Icon = icon;
  return (
    <div
      className={`group flex flex-col gap-5 p-8 rounded-2xl border transition-all duration-300 hover:-translate-y-2 hover:shadow-xl bg-white
        ${featured ? "border-gold/40 ring-1 ring-gold/20" : "border-outline-variant/30"}`}
    >
      <div className="w-12 h-12 rounded-xl bg-navy/5 flex items-center justify-center group-hover:bg-gold/10 transition-colors">
        <span className="material-symbols-outlined text-2xl text-navy group-hover:text-gold transition-colors">
          <Icon />
        </span>
      </div>
      <div>
        <h3 className="font-manrope text-h3 text-navy mb-2 group-hover:text-gold transition-colors">
          {title}
        </h3>
        <p className="font-manrope text-body-sm text-on-surface-variant">{description}</p>
      </div>
      {featured && (
        <span className="self-start font-manrope text-[10px] font-bold tracking-widest uppercase text-gold bg-gold/10 px-3 py-1 rounded-full border border-gold/20">
          Popular
        </span>
      )}
    </div>
  );
}

const services = [
  {
    icon: BookOpen,
    title: "Bookkeeping",
    description:
      "Full-cycle monthly and quarterly ledger maintenance and reconciliations tailored for high-growth SMEs.",
    featured: true,
  },
  {
    icon: Receipt,
    title: "GST / TDS",
    description:
      "Comprehensive Indian tax compliance — GST returns, TDS formalities — ensuring timely filings and zero penalties.",
    featured: true,
  },
  {
    icon: Globe,
    title: "Canadian Tax",
    description:
      "Specialized T1/T2 corporate and personal tax filing for Canadian entities and NRI expats.",
    featured: true,
  },
  {
    icon: Users,
    title: "Payroll",
    description:
      "End-to-end payroll management including benefits, PF, statutory deductions, and year-end summaries.",
    featured: true,
  },
  {
    icon: BarChart3,
    title: "Financial Statements",
    description:
      "Accurate P&L, Balance Sheets, cash flow statements, and audit-ready financial reporting.",
    featured: true,
  },
  {
    icon: CloudCheck,
    title: "Cloud Data",
    description:
      "Migration to Xero, QuickBooks, and Sage with real-time data synchronization and dashboards.",
    featured: true,
  },
  {
    icon: TrendingUp,
    title: "Cash Flow",
    description:
      "Strategic forecasting and liquidity management to keep your business financially healthy.",
    featured: true,
  },
  {
    icon: Handshake,
    title: "Business Advisory",
    description:
      "Growth strategy, structural planning, and CFO-level insights for scaling SMEs.",
    featured: true,
  },
];

export default function ServicesSection() {
  return (
    <section className="py-20 bg-surface-container-low" id="services">
      <div className="max-w-[1280px] mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px w-8 bg-gold" />
              <span className="font-manrope text-label-caps text-gold">COMPREHENSIVE SOLUTIONS</span>
            </div>
            <h2 className="font-manrope text-h1 text-navy">Specialized Financial Services</h2>
          </div>
          <a
            href="#contact"
            className="self-start md:self-end inline-flex items-center gap-2 font-manrope font-bold text-sm text-gold hover:gap-4 transition-all"
          >
            Discuss your needs <span className="material-symbols-outlined text-sm"><ChevronRight /></span>
          </a>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s) => (
            <ServiceCard key={s.title} {...s} />
          ))}
        </div>
      </div>
    </section>
  );
}
